document.addEventListener('DOMContentLoaded', () => {
  const colorInputs = document.querySelectorAll('.product-variant__item--color input[type="radio"]');
  const thumbnails = document.querySelectorAll('.thumbnail');
  const mainImage = document.querySelector('#main-product-image img');

  const updateMainImage = (selectedColor) => {
    const variant = window.productVariants.find(v => v.option1 === selectedColor);
    if (variant?.featured_media?.preview_image?.src && mainImage) {
      mainImage.src = variant.featured_media.preview_image.src;
    }
  };

  const updateThumbnails = (selectedColor) => {
    thumbnails.forEach(button => {
      const ids = button.getAttribute('data-variant-ids')?.split(',') || [];
      const match = ids.some(id => {
        const variant = window.productVariants.find(v => v.id == id);
        return variant?.option1 === selectedColor;
      });
      button.style.display = match ? 'block' : 'none';
    });
  };

  const handleChange = () => {
    const selected = document.querySelector('.product-variant__item--color input[type="radio"]:checked');
    if (selected) {
      const value = selected.value;
      updateMainImage(value);
      updateThumbnails(value);
    }
  };

  colorInputs.forEach(input => input.addEventListener('change', handleChange));
  handleChange(); // initialize on page load
});
